<template>
  <div class="base-popover">
    <el-popover
      ref="popover"
      v-bind="$attrs"
      :placement="placement"
      :title="title"
      :content="content"
      :trigger="trigger"
      :popper-class="`base-el-popover ${isDark ? 'is-dark' : ''}`"
    >
    </el-popover>
    <div class="popover-slot" v-popover:popover>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    content: String,
    placement: {
      type: String,
      default: 'top',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    isDark: Boolean,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.base-popover{
}
</style>



// WEBPACK FOOTER //
// src/components/common/popover/base-popover.vue